import PropTypes from 'prop-types';
import React, { CSSProperties, FormEvent, forwardRef } from 'react';

import Textarea from 'react-expanding-textarea';

type IExpandingTextAreaProps = {
  id?: string | number;
  disabled?: boolean;
  onChange: (evt: FormEvent<HTMLTextAreaElement>) => void;
  onBlur?: (evt: FormEvent<HTMLTextAreaElement>) => void;
  onClick?: (evt: FormEvent<HTMLTextAreaElement>) => void;
  value: string;
  placeholder?: string;
  style: CSSProperties;
};

const ExpandingTextArea = forwardRef(
  ({ id, disabled, onChange, onBlur, onClick, value, style, placeholder }: IExpandingTextAreaProps, ref) => {
    return (
      <Textarea
        ref={ref}
        className={'expandingtextarea react-grid-Comment'}
        autoComplete="off"
        disabled={disabled}
        key={id}
        onChange={onChange}
        onBlur={onBlur}
        onClick={onClick}
        value={value}
        style={style}
        placeholder={placeholder}
      />
    );
  }
);

ExpandingTextArea.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
};
ExpandingTextArea.defaultProps = {
  disabled: false,
  id: '',
  style: {},
};

export default ExpandingTextArea;
